import { Outlet } from 'react-router-dom'
import FloatingHelpButton from '@components/web/FloatingHelpButton'

export default function AuthLayout() {
  return (
    <div className="auth-theme min-h-[100dvh] lg:h-[100dvh] bg-[#fcfff8] flex items-center justify-center p-3 sm:p-4 lg:p-3 overflow-hidden">
      <div className="w-full max-w-7xl">
        <Outlet />
      </div>
      <FloatingHelpButton />
    </div>
  )
}
